// extracted by mini-css-extract-plugin
module.exports = {"MobileHeader":"MobileHeader_MobileHeader__2HjUs"};